function Research2026() {

    return (
        <>
            <div className="ml-10 mt-5">
                <div className="flex">
                    <div className="w-16">2026</div>
                    <div className="w-full">

                        <div className="flex">
                            <div className="w-16">July</div>
                            <div className="w-full">
                                <p><a href="https://ct2026.com" target='_blank'>"Polynomial functors from Lawvere theories."</a></p>
                                <p>International Category Theory Conference CT 2026, Johns Hopkins University</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default Research2026;